import React from "react";
import Navbar2 from "../../Components/Navbar2/Navbar2";
import { Footer } from '../../Components/Footer/Footer';
import Message from "../../Components/Message/Message";

const Chat = () => {
    return (
        <>
        <Navbar2 />
        <Message />
        <Footer />
        </>
    )
}

export default Chat;